import { Model } from 'json-api-models';

import type { Models, Schemas } from '../models.ts';

export class Roadmap extends Model<Schemas['roadmaps'], Models> {}
